import { FcsFlag } from "../unleash";

export const FlagsWoodPacking = {
  permission_wood_packing_enable: new FcsFlag.Flag(false)
};

export function initFlagsWoodPacking() {
  FcsFlag.register("featureWebsiteWoodPacking", FlagsWoodPacking);
}
